/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';

import { IOrderTemplateLineViewModel } from '../order-template';

export interface IOrderTemplateTableHeadingProps {
    productNumber: string;
    productName: string;
    productUnitPrice: string;
    productUOM: string;
    productQuantity: string;
    productActions: string;
    lines: IOrderTemplateLineViewModel[];
    isMobile: boolean;
    clickHandler(isChecked: boolean): void;
}

export interface IOrderTemplateTableShortHeading {
    productNumber: string;
    productActions: string;
}

/**
 * Order Template's table heading.
 */
export class OrderTemplateTableHeading extends React.PureComponent<IOrderTemplateTableHeadingProps> {
    public state: {
        isChecked: boolean;
    } = {
        isChecked: false
    };

    private readonly componentClassName: string = 'ms-table';

    public componentDidUpdate(prevProps: IOrderTemplateTableHeadingProps): void {
        this.setState({
            isChecked: this.props.lines.filter(line => !line.isChecked).length === 0
        });
    }

    public getOnChange = () => (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            isChecked: !this.state.isChecked
        }, () => {
            this.props.clickHandler(this.state.isChecked);
        });
    };

    public render(): JSX.Element {
        return (
            <thead>
                <tr className={`${this.componentClassName}__heading-row`}>
                    <th>
                        <label className='checkbox-container'>
                            <input
                                type='checkbox' aria-checked={this.state.isChecked} checked={this.state.isChecked}
                                onChange={this.getOnChange()} />
                            <span className='checkmark' />
                        </label>
                    </th>
                    <th />
                    <th>
                        {this.props.productNumber}
                    </th>
                    {!this.props.isMobile ? <th>
                        {this.props.productName}
                    </th> : null}
                    {!this.props.isMobile ? <th>
                        {this.props.productUnitPrice}
                    </th> : null}
                    {!this.props.isMobile ? <th>
                        {this.props.productUOM}
                    </th> : null}
                    {!this.props.isMobile ? <th>
                        {this.props.productQuantity}
                    </th> : null}
                    {!this.props.isMobile ? <th>
                        {this.props.productActions}
                    </th> : <td />}
                </tr>
            </thead>
        );
    }
}
